import api from '../api';

import { ParamsDataOrdersByCustomerId } from 'utils/typeServices';

export const GetOrdersByCustomerId = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<Array<ParamsDataOrdersByCustomerId>>('v1/Agendamento/GetListScheduling', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
